import { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/macro'
import { PatientIdentityStatus } from '@/core/models/patient.model'

export const PATIENT_IDENTITY_STATUS_LABELS: Record<PatientIdentityStatus, MessageDescriptor> = {
  [PatientIdentityStatus.PROVISIONAL]: msg`Provisional identity`,
  [PatientIdentityStatus.RECOVERED]: msg`Recovered identity`,
  [PatientIdentityStatus.VALIDATED]: msg`Validated identity`,
  [PatientIdentityStatus.QUALIFIED]: msg`Qualified identity`,
}

export function getIdentityStatusColor(
  status: PatientIdentityStatus,
): 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info' {
  switch (status) {
    case PatientIdentityStatus.PROVISIONAL:
      return 'error'
    case PatientIdentityStatus.RECOVERED:
      return 'info'
    case PatientIdentityStatus.VALIDATED:
      return 'secondary'
    case PatientIdentityStatus.QUALIFIED:
      return 'success'
    default:
      return 'default'
  }
}
